import { DefineGetters } from "vuex-type-helper";
import {
  RoofStructureGetters,
  RoofStructureState,
  IRoofStructure
} from "./types";

export const getters: DefineGetters<
  RoofStructureGetters,
  RoofStructureState
> = {
  getRoofStructureById: (state: RoofStructureState) => (id: string) =>
    state.roofStructures.find((roofStructure: IRoofStructure) => {
      return roofStructure._id === id;
    }),
  editingRoofStructure: (state: RoofStructureState) => state.editing,
  roofStructures: (state: RoofStructureState) => state.roofStructures,
  isLoading: (state: RoofStructureState) => state.makingApiRequest,
  getRoofStructuresLinks: (state: RoofStructureState) => state.links,
  getTotalRecords: ({ links, roofStructures }: RoofStructureState) =>
    links && links.totalRecords ? links.totalRecords : roofStructures.length
};
